import { render, staticRenderFns } from "./MobileProductCard.vue?vue&type=template&id=467c8752&"
import script from "./MobileProductCard.vue?vue&type=script&lang=js&"
export * from "./MobileProductCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileProductCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports